import React, { useContext } from "react";
import NewsItem from "../news/components/NewsItem";
import { AppContext } from "../store";
import LATEST_ARTICLE_QUERY from "../news/queries/LATEST_ARTICLE_QUERY";
import Query from "../common/Query";
import Article from "../news/types/Article";
import useIsAuthorized from "../hooks/useIsAuthorized";
import { Button } from "react-bootstrap";
import { loginRequest } from '../utils/authConfig';
import useOrgInfoLookupID from "../hooks/useOrgInfoLookupID";
import useOrgInfoVolunteerAccess from "../hooks/useOrgInfoVolunteerAccess";
import useOrgInfoConstituentID from "../hooks/useOrgInfoConstituentID"

const Home = () => {
  const { isAuthorized, login } = useIsAuthorized();
  const { state } = useContext(AppContext);
  const OrgInfoLookupID = useOrgInfoLookupID();
  const orgInfoVolunteerAccess = useOrgInfoVolunteerAccess();
  const orgInfoConstituentID = useOrgInfoConstituentID();
  const displayConstituentId = () =>
    orgInfoConstituentID ? orgInfoConstituentID : "Not Found";
  const displayLookupId = () =>
    OrgInfoLookupID ? OrgInfoLookupID : "Not Found";
  const displayVolunteerStatus = () =>
    orgInfoVolunteerAccess ? "Active" : "Not Active";
  const displayRoles = () => state.orgInfo?.roles;
  const displayNews = () =>
    state.orgInfo?.auth_id ? (
      <Query query={LATEST_ARTICLE_QUERY}>
        {({ data: { latestPost } }: { data: { latestPost: Article } }) => {
          if (latestPost) {
            return (
              <NewsItem
                article={latestPost}
                standalone={true}
                className="mt-5"
              />
            );
          } else {
            return null;
          }
        }}
      </Query>
    ) : null;
  if (isAuthorized) {
    return (
      <>
        <h1 className="mb-5">Welcome to the Volunteer Portal!</h1>
        {process.env.REACT_APP_DEBUG && (
          <p>
            <strong>Your Member ID</strong>: {displayLookupId()} <br />
            <strong>Your BBCRM Constituent ID</strong>: {displayConstituentId()}{" "}
            <br />
            <strong>Volunteer Status</strong>: {displayVolunteerStatus()} <br />
            <strong>Roles</strong>: {displayRoles()}
          </p>
        )}

        <p>
          <strong>Thank you</strong> for being a Ducks Unlimited volunteer!
          Whether you help organize a fundraising event or manage Sealed Bid
          Auction easels, we have the information and resources you need - right
          here online.
        </p>
        <p>
          The Volunteer Portal replaces the VolunteerGear website. In the months
          ahead, we will continue to improve the resources available to you and
          add additional features.
        </p>
        <p>
          If you encounter issues with the Volunteer Portal, please email{" "}
          <a href="mailto:wbond@ducks.org">wbond@ducks.org</a> or call
          901-758-3918.
        </p>
        {displayNews()}
      </>
    );
  }

  return (
    <>
      <h1 className="mb-4">Welcome to the Volunteer Portal!</h1>

      <p>
        <strong>Thank you</strong> for being a Ducks Unlimited volunteer!
        Whether you help organize a fundraising event or manage Sealed Bid
        Auction easels, we have the information and resources you need - right
        here online.
      </p>
      <p>
        The Volunteer Portal replaces the VolunteerGear website. In the months
        ahead, we will continue to improve the resources available to you and
        add additional features.
      </p>
      <p>
        If you have a MyDU account, please click the Login or Sign Up button and
        use your MyDU email address and password to access. If you do not have a
        MyDU account, click the Login or Sign Up button to create an account.
        Your registration will give you access to both MyDU and the Volunteer
        Portal.
      </p>
      <p>
        If you encounter issues logging in to the Volunteer Portal, please email{" "}
        <a href="mailto:wbond@ducks.org">wbond@ducks.org</a> or call
        901-758-3918.
      </p>

      <p>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => login(loginRequest, "loginRedirect")}
        >
          Login or Sign Up
        </Button>
      </p>
    </>
  );
};

export default Home;
